export default __webpack_public_path__ + "static/media/iconSideChair.2bc43b12.svg";